import { Blockchain, EVM_BLOCKCHAIN } from '@/constants/blockchain'
import { CURRENCIES } from '@/constants/currency'
import Currency from '@/models-ts/Currency'
import { getBalances as fetchBalances } from '@/servicies/balance'

/**
 * Removes insignificant trailing zeros
 * Ex. for 1.00100000 returns 1.00100
 * @param  {string} value
 * @param {number} minDecimal
 * @param {number} maxDecimal
 * @returns {string}
 */
export function decimalRemoveZeros(value: string, minDecimal: number = 5, maxDecimal: number = 8) {
  const val = value.replace(/(\.[0-9]*[1-9])0+$|\.0*$/, '$1')
  const arr = val.split(/[.,]+/)
  if (arr.length > 1) {
    return arr[1].length > minDecimal ? `${arr[0]}.${arr[1].substring(0, maxDecimal)}` : `${arr[0]}.${arr[1].padEnd(minDecimal, '0')}`
  } else {
    return `${arr[0]}.${new Array(minDecimal).fill(0).join('')}`
  }
}

/**
 * Fetch balances by Blockchain
 * @param {string} addressEth
 * @returns {[Blockchain]: {[Currency]}} map with balances in all blockhains
 */
export async function getBalances({ addressEth, addressTron }: { addressEth?: string; addressTron?: string }) {
  let balances: LX.ChainTokenMap = {}
  if (addressEth) {
    Object.assign(
      balances,
      EVM_BLOCKCHAIN.reduce(
        (accum, value) => ({
          ...accum,
          [value]: {},
        }),
        {}
      )
    )
  }
  balances[Blockchain.Tron] = {}

  if (addressEth) {
    const arrBalancesByBlockchains = await Promise.all(
      EVM_BLOCKCHAIN.map((blockchain: Blockchain) =>
        fetchBalances({
          address: addressEth,
          blockchain,
          tokens: CURRENCIES.filter((currency: Currency) => currency.blockchain === blockchain),
          chainId: undefined,
        })
      )
    )
    for (let [index, blockchain] of EVM_BLOCKCHAIN.entries()) {
      balances[`${blockchain}`] = (arrBalancesByBlockchains as Array<LX.TokenBalances>)[index]
    }
  }
  return balances
}

/**
 * Get balance of currency for address
 * @param {string} address
 * @param {Currency} currency
 * @return {string}
 */
export async function getBalanceByAddress({ address, currency }: { address: string; currency: Currency }) {
  let balance: any = await fetchBalances({
    address,
    blockchain: currency.blockchain,
    chainId: undefined,
    tokens: [currency],
  })
  return balance[currency.name]
}
